<template>
  <div>
    <div class="row footer-row justify-content-between">
      <div
        class="col-auto d-flex align-items-center grey-hover-blue"
        @click="
          goToWebTranslatedEntity({
            entityType: 'Knowledge',
            query: { source: 'navigation' },
          })
        "
      >
        <font-awesome-icon
          :icon="['fas', 'home']"
          class="mr-2"
        ></font-awesome-icon>
        <small> {{ $t('mayday-web.return-to-home') }} </small>
      </div>
      <div
        class="col-auto send-feedback grey-hover-blue"
        @click="openModalFeedback"
      >
        <font-awesome-icon
          :icon="['fas', 'megaphone']"
          class="mr-2"
        ></font-awesome-icon>
      </div>
    </div>
    <MaydayWebFeedbackDrawer
      v-if="modals.feedback"
      :display="modals.feedback"
      :content="content"
      :content-parents="contentParents"
      :path="bcPath"
      @close="modals.feedback = false"
      @success="handleSuccess"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import MaydayWebFeedbackDrawer from '../../MaydayWebFeedbackDrawer';

export default {
  name: 'mayday-node-main-footer',
  components: { MaydayWebFeedbackDrawer },
  data() {
    return {
      modals: { feedback: false },
      content: null,
      contentParents: [],
    };
  },
  props: {
    bcPath: Array,
  },
  computed: {
    ...mapState('webKnowledgeModule', ['focusKnowledge']),
    ...mapGetters('webKnowledgeModule', ['focusNavItem', 'focusDiagItem']),
  },
  methods: {
    handleSuccess() {
      this.modals.feedback = false;
      this.$message({
        message: this.$t('knowledge.modals.feedback.success'),
        type: 'success',
      });
    },
    openModalFeedback() {
      const { path } = this.$route;
      if (path.includes('/step')) {
        this.content = {
          id: this.focusDiagItem.id,
          type: this.focusDiagItem.type,
          label: this.focusDiagItem.label,
        };
        this.contentParents = this.focusDiagItem.ancestorsContent.reduce(
          (acc, ancestor) => {
            if (ancestor.type === 'Diagnostic') return acc; // No need to add as it is already present in breadcrumb path

            acc.push({
              id: ancestor.id,
              label: ancestor.label,
              type: ancestor.type,
            });
            return acc;
          },
          [],
        );
        this.contentParents.push(this.content); // Push current step as last item
      } else {
        this.content = {
          id: this.focusNavItem.id,
          type: this.focusNavItem.type || 'Case',
          label: this.focusNavItem.label,
        };
        this.contentParents = [];
      }

      this.modals.feedback = true;
    },
    ...mapActions('webKnowledgeModule', ['goToWebTranslatedEntity']),
  },
};
</script>
<style lang="scss" scoped>
.footer-row {
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 2px solid #f2f6fd;
  color: $grey-5-mayday;
}

.grey-hover-blue {
  color: $grey-7-mayday;
  &:hover {
    color: $blue-mayday;
    cursor: pointer;
  }
}
</style>
